{
  "title": "Bandeja de operaciones",
  "tabTitles": {
    "urgent": "🔴 ({{count}}) Bandeja de operaciones",
    "actionable": "({{count}}) Bandeja de operaciones",
    "default": "Bandeja de operaciones",
    "appDefault": "AirPlx"
  },
  "header": {
    "timeFilters": {
      "today": "Hoy",
      "tomorrow": "Mañana",
      "week": "Esta semana",
      "all": "Todo"
    },
    "statusLabels": {
      "allSetToday": "Todo listo para hoy",
      "nothingTomorrow": "Nada mañana",
      "clearForWeek": "Limpiar semana",
      "allCaughtUp": "¡Todo al día!",
      "arrivalsToday": "{{count}} llegada hoy",
      "arrivalsTomorrow": "{{count}} llegada mañana",
      "arrivalsWeek": "{{count}} llegada esta semana",
      "total": "{{count}} en total"
    },
    "newTails": "{{count}} nuevos",
    "searchPlaceholder": "Buscar matrícula, tipo, operador...",
    "refreshStatus": {
      "refreshing": "Actualizando...",
      "updated": "Actualizado {{timeAgo}}",
      "justNow": "ahora",
      "secondsAgo": "hace {{count}}s",
      "minuteAgo": "Hace 1m",
      "minutesAgo": "hace {{count}}m"
    }
  },
  "groups": {
    "unknownAircraft": {
      "title": "MATRÍCULAS",
      "tooltip": "Visitantes nuevos que necesitan ser configurados en tu sistema. Asócialos a aeronaves existentes o crea nuevas entradas."
    },
    "needsRouting": {
      "title": "ASIGNAR PARKING",
      "tooltip": "Llegadas que necesitan asignación de estacionamiento. Elige un hangar o plataforma para cada una."
    },
    "snoozed": {
      "count": "Pospuestos ({{count}})",
      "tooltip": "Elementos que ocultaste temporalmente. Volverán a aparecer en tu bandeja de entrada cuando termine el período de aplazamiento.",
      "snoozedUntil": "Pospuesto hasta {{date}}"
    }
  },
  "actionTypeGroup": {
    "urgencyLabels": {
      "now": "YA",
      "today": "HOY"
    },
    "itemCount": "{{count}} elemento (contraído)",
    "noItems": "No hay elementos en este grupo"
  },
  "bulkActions": {
    "selected": "{{count}} seleccionados",
    "breakdown": "({{quarantineCount}} desconocidos, {{tripCount}} viajes)",
    "mapAllTo": "Asignar todo a...",
    "snoozeAll": "Posponer todo",
    "buttons": {
      "mapToAircraft": "Asignar a aeronave",
      "assignLocation": "Asignar ubicación"
    }
  },
  "assignDropdown": {
    "assignTo": "Asignar a...",
    "searchPlaceholder": "Buscar...",
    "hangarsSection": "HANGARES",
    "rampsSection": "RAMPAS",
    "tooSmall": "Muy pequeño",
    "noDimensions": "Sin dimensiones",
    "noMatchingLocations": "No se encontraron ubicaciones",
    "noLocationsAvailable": "No hay ubicaciones disponibles",
    "dimensions": {
      "width": "{{width}}'W",
      "depth": "{{depth}}'D",
      "height": "{{height}}'H"
    }
  },
  "snooze": {
    "title": "Posponer hasta",
    "dateFormat": {
      "todayAt": "Hoy a las {{time}}",
      "tomorrowAt": "Mañana a las {{time}}"
    }
  },
  "messages": {
    "mapped": "Asignado {{tailNumber}} → {{aircraftName}}",
    "assigned": "Asignado {{tailNumber}} a {{locationName}}",
    "snoozed": "Pospuesto {{tailNumber}}",
    "unsnoozed": "Reactivado {{tailNumber}}",
    "bulkSnoozed": "{{count}} elementos pospuestos",
    "bulkMapped": "Asignados {{count}} aviones a {{aircraftName}}",
    "bulkMappedPartial": "Mapeados {{successCount}}/{{totalCount}} ({{failCount}} fallidos)",
    "bulkAssignedHangar": "Asignados {{count}} viajes a {{locationName}}",
    "bulkAssignedRamp": "Asignados {{count}} viajes a {{locationName}}",
    "bulkAssignedHangarPartial": "Asignados {{successCount}}/{{totalCount}} viajes (fallidos: {{sampleFails}}{{moreFails}})",
    "bulkAssignedRampPartial": "Asignados {{successCount}}/{{totalCount}} viajes (fallidos: {{sampleFails}}{{moreFails}})",
    "bulkAssignedHangarFailed": "No se pudieron asignar los viajes: {{sampleFails}}{{moreFails}}",
    "bulkAssignedRampFailed": "No se pudieron asignar los viajes: {{sampleFails}}{{moreFails}}"
  },
  "errors": {
    "resolveFailed": "No se pudo resolver {{tailNumber}}: {{error}}",
    "assignFailed": "Error al asignar: {{error}}",
    "snoozeFailed": "No se pudo posponer: {{error}}",
    "unsnoozeFailed": "Error al reactivar: {{error}}",
    "bulkResolveFailed": "Resolución masiva fallida: {{error}}",
    "unknownError": "Error desconocido",
    "loadFailed": "Error al cargar bandeja: {{error}}"
  },
  "emptyStates": {
    "today": {
      "title": "¡Todo listo para hoy!",
      "message": "No hay llegadas pendientes de estacionamiento.",
      "laterThisWeek": "{{count}} llegadas en los próximos días",
      "newTailsToSetup": "{{count}} nuevas aeronaves por configurar",
      "previewThisWeek": "Vista previa semanal",
      "setupNewTails": "Nuevas matrículas"
    },
    "tomorrow": {
      "title": "Nada programado para mañana",
      "message": "Vuelve más tarde o ver todas las llegadas.",
      "viewAll": "Ver todo"
    },
    "week": {
      "title": "Libre para la semana",
      "message": "Todas las llegadas tienen estacionamiento asignado.",
      "setupNewTails": "Configurar {{count}} Nuevas Matrículas"
    },
    "all": {
      "title": "¡Todo al día!",
      "message": "No hay elementos que requieran atención ahora."
    }
  },
  "quarantineCard": {
    "noTypeHint": "Sin tipo",
    "buttons": {
      "matchTo": "Vincular a {{type}}",
      "findAircraft": "Buscar aeronave",
      "later": "Después"
    },
    "labels": {
      "searchAircraft": "Buscar aeronave..."
    },
    "tooltips": {
      "searchForType": "Buscar \"{{type}}\" en la base de datos de aeronaves"
    }
  },
  "tripCard": {
    "buttons": {
      "later": "Después"
    },
    "tooltips": {
      "aircraftTooLarge": "Aeronave demasiado grande",
      "mostUsedLocation": "Ubicación más usada ({{count}} asignaciones)",
      "assignTo": "Asignar a {{name}}",
      "moreLocations": "Más ubicaciones"
    }
  }
}
